var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomeMeetingBooked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "119px",
    height: "102px",
    viewBox: "0 0 119 102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plans-update",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "In-process-ADVANCED-BEFORE-SCHEDULE-DATA-ACCEPTED",
    transform: "translate(-141.000000, -114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_screen_meeting_booked",
    transform: "translate(141.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 6,
    width: 105,
    height: 80
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,6 L105,86 L0,86 L0,6 L105,6 Z M103,8 L2,8 L2,84 L103,84 L103,8 Z",
    id: "Rectangle",
    fill: "#302745",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,25 L12,25 L12,39 L27,39 L27,25 Z M25,27 L25,37 L14,37 L14,27 L25,27 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 22,
    y: 0,
    width: 7,
    height: 17,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 80,
    y: 0,
    width: 7,
    height: 17,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,-1 C23.0147186,-1 21,1.01471863 21,3.5 L21,13.5 C21,15.9852814 23.0147186,18 25.5,18 C27.9852814,18 30,15.9852814 30,13.5 L30,3.5 C30,1.01471863 27.9852814,-1 25.5,-1 Z M25.5,1 C26.8807119,1 28,2.11928813 28,3.5 L28,13.5 C28,14.8807119 26.8807119,16 25.5,16 C24.1192881,16 23,14.8807119 23,13.5 L23,3.5 C23,2.11928813 24.1192881,1 25.5,1 Z",
    id: "Rectangle",
    fill: "#302745",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5,-1 C81.0147186,-1 79,1.01471863 79,3.5 L79,13.5 C79,15.9852814 81.0147186,18 83.5,18 C85.9852814,18 88,15.9852814 88,13.5 L88,3.5 C88,1.01471863 85.9852814,-1 83.5,-1 Z M83.5,1 C84.8807119,1 86,2.11928813 86,3.5 L86,13.5 C86,14.8807119 84.8807119,16 83.5,16 C82.1192881,16 81,14.8807119 81,13.5 L81,3.5 C81,2.11928813 82.1192881,1 83.5,1 Z",
    id: "Rectangle",
    fill: "#302745",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,25 L25,25 L25,39 L40,39 L40,25 Z M38,27 L38,37 L27,37 L27,27 L38,27 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5,25 L38,25 L38,39 L53.5,39 L53.5,25 Z M51.5,27 L51.5,37 L40,37 L40,27 L51.5,27 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,25 L51.5,25 L51.5,39 L67,39 L67,25 Z M65,27 L65,37 L53.5,37 L53.5,27 L65,27 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,25 L65,25 L65,39 L80,39 L80,25 Z M78,27 L78,37 L67,37 L67,27 L78,27 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,25 L78,25 L78,39 L93,39 L93,25 Z M91,27 L91,37 L80,37 L80,27 L91,27 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,37 L12,37 L12,51 L27,51 L27,37 Z M25,39 L25,49 L14,49 L14,39 L25,39 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,37 L25,37 L25,51 L40,51 L40,37 Z M38,39 L38,49 L27,49 L27,39 L38,39 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5,37 L38,37 L38,51 L53.5,51 L53.5,37 Z M51.5,39 L51.5,49 L40,49 L40,39 L51.5,39 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,37 L65,37 L65,51 L80,51 L80,37 Z M78,39 L78,49 L67,49 L67,39 L78,39 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,37 L78,37 L78,51 L93,51 L93,37 Z M91,39 L91,49 L80,49 L80,39 L91,39 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,49 L12,49 L12,62.5 L27,62.5 L27,49 Z M25,51 L25,60.5 L14,60.5 L14,51 L25,51 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,49 L25,49 L25,62.5 L40,62.5 L40,49 Z M38,51 L38,60.5 L27,60.5 L27,51 L38,51 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5,49 L38,49 L38,62.5 L53.5,62.5 L53.5,49 Z M51.5,51 L51.5,60.5 L40,60.5 L40,51 L51.5,51 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,49 L51.5,49 L51.5,62.5 L67,62.5 L67,49 Z M65,51 L65,60.5 L53.5,60.5 L53.5,51 L65,51 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,49 L78,49 L78,62.5 L93,62.5 L93,49 Z M91,51 L91,60.5 L80,60.5 L80,51 L91,51 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,60.5 L12,60.5 L12,74 L27,74 L27,60.5 Z M25,62.5 L25,72 L14,72 L14,62.5 L25,62.5 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,60.5 L25,60.5 L25,74 L40,74 L40,60.5 Z M38,62.5 L38,72 L27,72 L27,62.5 L38,62.5 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5,60.5 L38,60.5 L38,74 L53.5,74 L53.5,60.5 Z M51.5,62.5 L51.5,72 L40,72 L40,62.5 L51.5,62.5 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,60.5 L51.5,60.5 L51.5,74 L67,74 L67,60.5 Z M65,62.5 L65,72 L53.5,72 L53.5,62.5 L65,62.5 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,60.5 L65,60.5 L65,74 L80,74 L80,60.5 Z M78,62.5 L78,72 L67,72 L67,62.5 L78,62.5 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,60.5 L78,60.5 L78,74 L93,74 L93,60.5 Z M91,62.5 L91,72 L80,72 L80,62.5 L91,62.5 Z",
    id: "Rectangle",
    fill: "#B9B6C2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#0EBC68",
    points: "66 50 79 50 79 61.5 66 61.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,49 L65,49 L65,62.5 L80,62.5 L80,49 Z M78,51 L78,60.5 L67,60.5 L67,51 L78,51 Z",
    id: "Rectangle",
    fill: "#008F4A",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(90.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#0EBC68",
    cx: 14.5,
    cy: 14.5,
    r: 14.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-46",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "20.8363297 8.41320884 22.2505433 9.8274224 11.5434365 20.5345292 6.36846548 15.3595582 7.78267904 13.9453446 11.543 17.706"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeMeetingBooked);
export default __webpack_public_path__ + "static/media/welcome_meeting_booked.db9121be.svg";
export { ForwardRef as ReactComponent };